import React, { SVGProps } from 'react'
const SvgInviteGuestGrayscale = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={79}
    height={75}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#Invite-Guest-Grayscale_svg__a)">
      <mask
        id="Invite-Guest-Grayscale_svg__b"
        width={69}
        height={70}
        x={5}
        y={3}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}
      >
        <path
          fill="#fff"
          d="M39.5 73C58.554 73 74 57.33 74 38S58.554 3 39.5 3 5 18.67 5 38s15.446 35 34.5 35"
        />
      </mask>
      <g mask="url(#Invite-Guest-Grayscale_svg__b)">
        <g filter="url(#Invite-Guest-Grayscale_svg__c)">
          <path
            fill="#000"
            d="M39.5 73C58.554 73 74 57.33 74 38S58.554 3 39.5 3 5 18.67 5 38s15.446 35 34.5 35"
          />
        </g>
        <path
          fill="#FCFCFF"
          d="M39.5 73C58.554 73 74 57.33 74 38S58.554 3 39.5 3 5 18.67 5 38s15.446 35 34.5 35"
        />
        <g filter="url(#Invite-Guest-Grayscale_svg__d)">
          <path
            fill="#000"
            d="M-4.82 72.149q-5.633-25.39 16.893-25.39 22.524 0 16.893 25.39"
          />
        </g>
        <path
          fill={props.fill || '#697080'}
          d="M-4.82 72.149q-5.633-25.39 16.893-25.39 22.524 0 16.893 25.39"
        />
        <g filter="url(#Invite-Guest-Grayscale_svg__e)">
          <path
            fill="#000"
            d="M12.072 49.43c5.972 0 10.812-4.882 10.812-10.905s-4.84-10.904-10.812-10.904c-5.97 0-10.811 4.882-10.811 10.904S6.1 49.43 12.072 49.43"
          />
        </g>
        <path
          fill="#DADBE0"
          d="M12.072 49.43c5.972 0 10.812-4.882 10.812-10.905s-4.84-10.904-10.812-10.904c-5.97 0-10.811 4.882-10.811 10.904S6.1 49.43 12.072 49.43"
        />
        <g filter="url(#Invite-Guest-Grayscale_svg__f)">
          <path
            fill="#000"
            d="M56.445 62.25Q52.41 44.113 68.552 44.113T80.659 62.25"
          />
        </g>
        <path
          fill="#BDC1C8"
          d="M56.445 62.25Q52.41 44.113 68.552 44.113T80.659 62.25"
        />
        <g filter="url(#Invite-Guest-Grayscale_svg__g)">
          <path
            fill="#000"
            d="M68.552 46.307c4.28 0 7.748-3.487 7.748-7.79 0-4.3-3.469-7.788-7.748-7.788-4.28 0-7.749 3.487-7.749 7.789s3.47 7.789 7.749 7.789"
          />
        </g>
        <path
          fill="#D8DADE"
          d="M68.552 46.307c4.28 0 7.748-3.487 7.748-7.79 0-4.3-3.469-7.788-7.748-7.788-4.28 0-7.749 3.487-7.749 7.789s3.47 7.789 7.749 7.789"
        />
        <g filter="url(#Invite-Guest-Grayscale_svg__h)">
          <path
            fill="#000"
            d="M16.092 81.304Q8.302 46.12 39.462 46.12q31.158 0 23.368 35.184"
          />
        </g>
        <path
          fill={props.fill || '#B3B7BE'}
          d="M16.092 81.304Q8.302 46.12 39.462 46.12q31.158 0 23.368 35.184"
        />
        <g filter="url(#Invite-Guest-Grayscale_svg__i)">
          <path
            fill="#000"
            d="M39.6 51.646c8.26 0 14.956-6.765 14.956-15.11 0-8.346-6.696-15.111-14.956-15.111s-14.956 6.765-14.956 15.11c0 8.346 6.696 15.11 14.956 15.11"
          />
        </g>
        <path
          fill={props.fill || '#B3B7BE'}
          d="M39.6 51.646c8.26 0 14.956-6.765 14.956-15.11 0-8.346-6.696-15.111-14.956-15.111s-14.956 6.765-14.956 15.11c0 8.346 6.696 15.11 14.956 15.11"
        />
      </g>
    </g>
    <defs>
      <filter
        id="Invite-Guest-Grayscale_svg__a"
        width={79}
        height={80}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
      <filter
        id="Invite-Guest-Grayscale_svg__c"
        width={79}
        height={80}
        x={0}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
      <filter
        id="Invite-Guest-Grayscale_svg__d"
        width={44.039}
        height={33.391}
        x={-9.947}
        y={43.758}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
      <filter
        id="Invite-Guest-Grayscale_svg__e"
        width={29.623}
        height={29.809}
        x={-2.739}
        y={24.621}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
      <filter
        id="Invite-Guest-Grayscale_svg__f"
        width={31.828}
        height={24.136}
        x={52.638}
        y={42.113}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
      <filter
        id="Invite-Guest-Grayscale_svg__g"
        width={21.497}
        height={21.578}
        x={57.803}
        y={28.729}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
      <filter
        id="Invite-Guest-Grayscale_svg__h"
        width={59.854}
        height={45.184}
        x={9.534}
        y={43.12}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
      <filter
        id="Invite-Guest-Grayscale_svg__i"
        width={39.912}
        height={40.221}
        x={19.644}
        y={18.425}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={2.5} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1839_442"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1839_442"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default SvgInviteGuestGrayscale
